// React
import { useEffect, useState } from "react";
// Firebase
import { projectAuth } from "../firebase/config";
// Hook
import { useAuthContext } from "./useAuthContext";
import { signOut } from "firebase/auth";

export const useLogout = () => {
  // useState variables
  const [isCancelled, setIsCancelled] = useState(false);
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  // useAuthContext variable
  const { dispatch } = useAuthContext();

  const logout = async () => {
    // Updating useState
    setError(null);
    setIsPending(true);

    // Sign out the user
    try {
      await signOut(projectAuth);

      // dispatch logout action
      dispatch({ type: "LOGOUT" });

      // Updating useState
      if (!isCancelled) {
        setError(null);
        setIsPending(false);
      }
    } catch (err) {
      // Updating useState
      if (!isCancelled) {
        setError(err.message);
        setIsPending(false);
        console.log(err.message);
      }
    }
  };

  // Cleanup function
  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  return { logout, error, isPending };
};
